(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-skinorya"] && !Shopify.designMode) return;
  try {
    
  class SkinoryaStats {
    constructor(section) {
      this.section = section;
      this.sectionId = section.getAttribute('data-section-id');
      this.dataElement = document.getElementById(`skinorya-stats-data-${this.sectionId}`);
      
      if (!this.dataElement) return;
      
      this.config = JSON.parse(this.dataElement.textContent);
      this.animated = false;
      this.init();
    }

    init() {
      if (!this.config.animationEnabled) return;
      
      this.setupIntersectionObserver();
    }

    setupIntersectionObserver() {
      const observerOptions = {
        threshold: 0.2,
        rootMargin: '0px 0px -50px 0px'
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.animated) {
            this.animated = true;
            this.animateStats();
            observer.unobserve(this.section);
          }
        });
      }, observerOptions);

      observer.observe(this.section);
    }

    animateStats() {
      const numberElements = this.section.querySelectorAll('[data-stat-value]');
      
      numberElements.forEach((element, index) => {
        setTimeout(() => {
          this.animateNumber(element);
        }, index * 100);
      });
    }

    animateNumber(element) {
      const finalValue = element.getAttribute('data-stat-value');
      const isPercentage = finalValue.includes('%');
      const isCustomers = finalValue.includes(',');
      
      let numericValue;
      
      if (isPercentage) {
        numericValue = parseInt(finalValue);
      } else if (isCustomers) {
        numericValue = parseInt(finalValue.replace(/,/g, ''));
      } else {
        numericValue = parseInt(finalValue);
      }

      const duration = 2000;
      const startTime = performance.now();
      const startValue = 0;

      element.classList.add('counting');

      const animate = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        
        // Easing function for smooth animation
        const easeOutQuad = progress < 0.5
          ? 2 * progress * progress
          : 1 - Math.pow(-2 * progress + 2, 2) / 2;

        const currentValue = Math.floor(startValue + (numericValue - startValue) * easeOutQuad);

        if (isPercentage) {
          element.textContent = currentValue + '%';
        } else if (isCustomers) {
          element.textContent = currentValue.toLocaleString();
        } else {
          element.textContent = currentValue.toLocaleString();
        }

        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          element.textContent = finalValue;
          element.classList.remove('counting');
        }
      };

      requestAnimationFrame(animate);
    }
  }

  // Initialize on DOM ready
  function initSkinoryaStats() {
    const sections = document.querySelectorAll('[data-section-type="skinorya-stats"]');
    sections.forEach(section => {
      new SkinoryaStats(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSkinoryaStats);
  } else {
    initSkinoryaStats();
  }

  // Shopify theme editor support
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', () => {
      initSkinoryaStats();
    });
  }

  } catch(e) { console.error(e); }
})();
})();
